import React from "react";

import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template.jsx";

export default class MedicalRecordsAppointments extends BaseRoute {
  @service("repositories/case-repository") caseRepository;
  @service("repositories/user-repository") userRepository;
  @service("repositories/appointment-repository") appointmentRepository;

  element = (<Template />);

  async loader({ params }) {
    const { id } = params;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { _case: null, client: null };
    } else {
      try {
        const _case = await this.caseRepository.findRecord(id);
        const _caseId = _case["client"]["id"];
        return { _case, _caseId };
      } catch (error) {
        console.error(`Error getting case: ${id}`, error);
        return { _case: null, _caseId: null };
      }
    }
  }
}
